<div class="chart-wrapper">
  <div class="header-content">
    <div class="title-content">
      <h6 [matTooltip]="name?.length > 50 ? name : null"
        matTooltipHideDelay="300"
      >{{ name }}</h6>
      <p>{{ unit }}</p>
    </div>
    @if (layerOptions?.length) {
      <div>
        <mds-dropdown-menu
          [minWidth]="'200px'"
          [helperTextPre]="'Impact Category'"
          [options]="layerOptions"
          [formControl]="layerFormControl"
          >
        </mds-dropdown-menu>
      </div>
    }
  </div>
  <div>
    @if (loading) {
      <mds-loader></mds-loader>
    }

    @if (!loading) {
      @if (isEmpty) {
        <app-empty-chart [description]="emptyChart.description"
        [title]="emptyChart.title"></app-empty-chart>
      }
      @if (!isEmpty && chartOptions) {
        <div #chartContainer class="chart-content">
          <highcharts-chart
            [Highcharts]="highcharts"
            [options]="chartOptions"
            class="chart-1">
          </highcharts-chart>
        </div>
      }
    }
  </div>
</div>
